let currentIndex = 0;
function moveSlide(index) {
    const slider = document.querySelector('.three-col-images__slider');
    const dots = document.querySelectorAll('.three-col-images__dot');
    currentIndex = index;
    slider.style.transform = `translateX(-${index * 100}%)`;
    dots.forEach(dot => dot.classList.remove('three-col-images__active'));
    dots[index].classList.add('three-col-images__active');
}

const sliderContainer = document.querySelector('.three-col-images__slider');
let touchstartX = 0;
let touchendX = 0;
const swipeThreshold = 50;

sliderContainer.addEventListener('touchstart', function(e) {
    touchstartX = e.changedTouches[0].clientX;
}, false);

sliderContainer.addEventListener('touchend', function(e) {
    touchendX = e.changedTouches[0].clientX;
    handleSwipe();
}, false);

function handleSwipe() {
    const diff = touchstartX - touchendX;
    if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
            const dots = document.querySelectorAll('.three-col-images__dot');
            if (currentIndex < dots.length - 1) {
                moveSlide(currentIndex + 1);
            }
        } else {
            if (currentIndex > 0) {
                moveSlide(currentIndex - 1);
            }
        }
    }
}